import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'removeAfterDollar'
})

// Return first string from paragraph

export class RemovePipe implements PipeTransform {

    transform(value: string, args?: any): any {
       
        if (value) {

            var i = value.indexOf('$');
           
            value = i ? value.substring(0, i) : value;

            //Using split 
            return value;

        }

        return value;
    }

}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/pipesFiles/removeChar.pipe.ts